import permission from './permission.js'
import control from './control.js'
import disabled from './disabled.js'
import scroll from './scroll.js'
import focus from './focus.js'
import roles from './roles.js'
import tooltip from './tooltip.js'
import crosswiseScroll from './crosswiseScroll.js'

// 自定义指令
const directives = { permission,control,disabled,scroll,focus,roles,tooltip,crosswiseScroll }

export default {
  install(App) {
    Object.keys(directives).forEach((key) => {
      App.directive(key, directives[key])
    })
  }
}
